<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/task-notice/table">任务提示列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">{{$route.meta.title}}</template>
      <div class="device device-iphone-x">
        <div class="device-frame">
          <div v-if="noticeDetail" class="mobile-container">
            <div class="notice-container">
              <p class="title">任务提示</p>
              <p v-if="[1,3].includes(noticeDetail.notice_type)" class="content">{{noticeDetail.content}}</p>
              <img v-if="[2,3].includes(noticeDetail.notice_type)" model :src="noticeDetail.images[0]" class="image">
              <p class="confirm">我知道了</p>
            </div>
          </div>
        </div>
        <div class="device-stripe"></div>
        <div class="device-header"></div>
        <div class="device-sensors"></div>
        <div class="device-btns"></div>
        <div class="device-power"></div>
      </div>

      <br>
      <router-link to="/task-notice/table">
        <el-button type="primary">返回</el-button>
      </router-link>
    </layout-panel>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  data () {
    return {
      noticeDetail: null,
    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.id = this.$route.params.id
    this.id > 0 && this.setDetailData(this.id)
  },
  methods: {
    ...Vuex.mapActions([]),
    setDetailData (id) {
      request.page('getTaskNoticeDetail', {id}).then(({data}) => {
        this.noticeDetail = data
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
@import '@core/style/devices/devices.scss';
.mobile-container {
  border-radius: 40px;
  background-color: #707070;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: all-scroll;
}

.notice-container {
  width: 270px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: white;

  .image {
    width: 254px;
    height: 254px;
    object-fit: contain;
    border-radius: 8px;
  }
  .title {
    font-size: 15px;
    color: #333;
    padding: 4px 0;
    font-weight: bold;
  }

  .content {
    font-size: 15px;
    padding: 8px 8px;
    color: #333;
    max-height: 300px;
    overflow: scroll;
  }

  .confirm {
    width: 270px;
    margin: 8px 0;
    padding-top: 8px;
    font-size: 15px;
    text-align: center;
    color: #FF9900;
    border-top: 1px solid #DDDDDD;
  }
}

p {
  padding: 0;
  margin: 0;
}

// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/task-notice/pages/TaskNoticeDetail.vue